import { atom } from "recoil";

export const tournamentsBannersAddModalStore = atom({
	key: "tournamentsBannersAddModalStore",
	default: {
		show: false,
		loaded: false,
		image: "",
		currentOption: {
			type: [{value: "local", label: "local"}, {value: "international", label: "international",}, {value: "mixed", label: "mixed",}],
		},
		type: "",
		name: "",
		badge: "",
		gameID: "",
		pool: "",
		limit: "0",
		date: "",
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
